import { useLocation, useNavigate, useParams } from "react-router-dom";
import Button from "@/components/Button";
import { useMemo } from "react";
import { Image } from "@nextui-org/react";

// Function to count incorrect answers
function countIncorrectAnswers(quizResults, questionsCount) {
    const notAnsweredQuestions = questionsCount - quizResults?.length;
    return (
        quizResults?.filter((result) => result.attributes && !result.attributes.isCorrect).length + notAnsweredQuestions
    );
}

function QuizResult() {
    const { state } = useLocation();
    const { courseId, grade, lectureId, quizId, attemptId } = useParams();
    const navigate = useNavigate();

    const quizResults = state?.data;
    const validQuestionsCount = quizResults?.validQuestionsCount;

    // Calculate incorrect count
    const incorrectCount = useMemo(() => {
        if (!quizResults?.data) return 0;

        return countIncorrectAnswers(quizResults?.data, validQuestionsCount);
    }, [quizResults, validQuestionsCount]);

    // Format scorePercentage
    const scorePercentage = useMemo(() => {
        const percentage = quizResults?.scorePercentage || 0;
        return Number.isInteger(percentage)
            ? percentage.toFixed(0)
            : percentage.toFixed(2);
    }, [quizResults]);

    return (
        <div className="flex flex-col items-center justify-center w-full h-full gap-5 py-40 bg-[#f7f7f7] rounded-lg">
            <Image
                src={
                    quizResults?.isSuccess
                        ? "/images/courses/congratulations.gif"
                        : "/images/SadFace.webp"
                }
                alt="sad face if is Error"
                width="300px"
                decoding="async"
                loading="lazy"
            />

            <p className="mt-2 font-bold text-md lg:text-2xl text-blue-color-primary">
                {quizResults?.isSuccess
                    ? "تهانينا لقد نجحت في الأختبار"
                    : "برجاء المذاكرة مره اخري واعادة الاختبار"}
            </p>

            <div className="px-6 py-2 text-center rounded-lg bg-primary-color-light ">
                <p className="text-blue-color-primary">
                    نتيجة الأختبار :
                    <span className="font-semibold">{scorePercentage}%</span>
                </p>
            </div>

            <p className="text-blue-color-primary">
                عدد الأسئلة الخاطئه :
                <span className="font-semibold">{incorrectCount}</span>
            </p>

            {quizResults?.isSuccess && <Button
                type="primary"
                className="w-80"
                onClick={() =>
                    navigate(
                        `/${grade}/courses/${courseId}/lectures/${lectureId}/quiz/${quizId}/${attemptId}/answers`,
                        { replace: true }
                    )
                }
            >
                نموذج الاجابات
            </Button>}
            <Button
                type="primary"
                className="w-80"
                onClick={() =>
                    navigate(
                        `/${grade}/courses/${courseId}/lectures/${lectureId}`,
                        { replace: true }
                    )
                }
            >
                عودة للمحاضره
            </Button>
        </div>
    );
}

export default QuizResult;
